// Copyright ©️ 2026 eVolve MEP, LLC

import './nav.css';

import React, { useMemo } from 'react';

import { NavLink, Flex } from '@mantine/core';

import { navbarTransitionStyle } from 'app/Layout/NavBar/useAppShell';
import { EvolveIcon, type EvolveIconName } from 'assets/icons/EvolveIcon';
import { replaceSpaceToDash } from 'helpers/stringFunctions';

import classes from './StyledNavLink.module.css';

type Props = {
  ref?: React.Ref<HTMLAnchorElement>;
  label: string;
  isNew?: boolean;
  withLabel?: boolean;
  active?: boolean;
  onClick: () => void;
  icon?: EvolveIconName;
};

export const StyledNavLink = ({ ref, label, isNew, active, onClick, icon, withLabel = true }: Props) => {
  const dataTestIdOfItem = useMemo(() => `nav-item-${replaceSpaceToDash(label)}`, [label]);

  return (
    <NavLink
      leftSection={icon ? <EvolveIcon icon={icon} color="app-shell-gray.5" /> : undefined}
      ref={ref}
      className={classes.navLink}
      label={
        <Flex gap="xs">
          {label} {isNew && <span className={classes.newMarker}>New!</span>}
        </Flex>
      }
      active={active}
      onClick={onClick}
      h={34}
      px={10}
      py={2}
      variant="filled"
      color="var(--mantine-color-app-shell-gray-7)"
      classNames={{
        root: classes.root,
        body: classes.body,
        label: classes.label,
      }}
      styles={{
        root: {
          transition: navbarTransitionStyle,
          color: active ? 'white' : undefined,
        },
        label: {
          opacity: withLabel ? 1 : 0,
          transition: navbarTransitionStyle,
        },
      }}
      data-testid={dataTestIdOfItem}
    />
  );
};
